import { render, staticRenderFns } from "./AiComparationItem.vue?vue&type=template&id=2c9eff42&scoped=true"
import script from "./AiComparationItem.vue?vue&type=script&lang=js"
export * from "./AiComparationItem.vue?vue&type=script&lang=js"
import style0 from "./AiComparationItem.vue?vue&type=style&index=0&id=2c9eff42&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c9eff42",
  null
  
)

export default component.exports